const countries = [
	{ name: 'Malaysia', code: 'my' },
	{ name: 'Singapore', code: 'sg' },
	{ name: 'Thailand', code: 'th' },
	{ name: 'Indonesia', code: 'id' },
	{ name: 'Philippines', code: 'ph' },
	{ name: 'Cambodia', code: 'kh' },
	{ name: 'Vietnam', code: 'vn' },
];

export default countries;